<template>
  <div class="account-settings">
    <header class="mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">

        <span>{{ i18n().title }}</span>

        <div class="mdl-layout-spacer"></div>

      </div>
    </header>
    <div class="cards">
        <ChangeUserData></ChangeUserData>

        <ChangePassword></ChangePassword>

        <ChangeEmail></ChangeEmail>
    </div>
  </div>
</template>

<script>
  import ChangePassword from "./emailPassword/ChangePassword.vue"
  import ChangeEmail from "./emailPassword/ChangeEmail.vue"
  import ChangeUserData from "./user/ChangeUserData.vue"

  import i18n from "i18n"

  export default {
    name: 'account-settings',
    metaInfo: {
      title: i18n().accountSettings.title
    },
    components: {
      ChangePassword, ChangeEmail, ChangeUserData
    },
    data () {
      return {
      }
    },
    methods: {
      i18n() {return i18n().accountSettings}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media screen and (max-width: 1024px) {
    .mdl-layout__header {
      display: block;
    }
  }

  .mdl-grid {
    align-items: center;
    justify-content: center;
  }

  .cards {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  .cards > div {
    margin: 5px;
  }

</style>



// WEBPACK FOOTER //
// AccountSettings.vue?4e7196f0